import cx from 'classnames';
import React from 'react';

import { Button } from '@flixbus/honeycomb-react';

import Scroller from 'common/Scroller';
import AssignmentModifications from 'pages/WorkAssignments/components/AssignmentModifications';
import { buildBreakdownReasonsForAssignments as buildBreakdownReasons } from 'pages/WorkAssignments/components/AssignmentModifications/utils';
import Station from 'pages/WorkAssignments/components/Station';
import {
	COL_WIDTH,
	totalColsFromStations,
} from 'pages/WorkAssignments/components/WorkAssignmentCard/utils';

import { STATION_VIEWER_TEXTS } from './texts';

import styles from './styles.module.css';

const SCROLLER_STYLES = {
	fade: false,
	navWrapLeft: { left: '-42px' },
	navWrapRight: { right: '-42px' },
	navLeft: { width: '32px', height: '32px', boxShadow: 'none' },
	navRight: { width: '32px', height: '32px', boxShadow: 'none' },
};

const StationViewer = ({ stations, stationActuals, breakdown, sequences = [], onEditData }) => {
	const isOneScreen = stations.length <= 6;
	const totalCols = totalColsFromStations(stations.length);
	const gridTemplateColumns = isOneScreen
		? `repeat(${totalCols}, 1fr)`
		: `repeat(${totalCols}, ${COL_WIDTH}px)`;

	return (
		<div className={styles.viewerWrap}>
			<div className={styles.stationsSection}>
				<Scroller scrollStep={COL_WIDTH * 2} styles={SCROLLER_STYLES}>
					<div className={styles.stationsGrid} style={{ gridTemplateColumns }}>
						{stations.map((station, idx) => {
							const isFirst = idx === 0;
							const isLast = idx === stations.length - 1;
							const entry = stationActuals[idx] ?? {
								actualArrival: null,
								actualDeparture: null,
							};

							return (
								<div
									key={station.id}
									className={cx(styles.stationCell, {
										[styles.spanWidth1]: isFirst || isLast,
										[styles.spanWidth2]: !isFirst && !isLast,
									})}
								>
									<Station
										isFirst={isFirst}
										isLast={isLast}
										station={station}
										timezone={station.timezone}
										actualDeparture={isLast ? null : entry.actualDeparture}
										actualArrival={isFirst ? null : entry.actualArrival}
									/>
								</div>
							);
						})}
					</div>
				</Scroller>
			</div>
			{breakdown && (
				<AssignmentModifications
					breakdown={breakdown}
					breakdownReasons={buildBreakdownReasons(breakdown)}
					sequences={sequences}
				/>
			)}
			<div className={styles.editDataRow}>
				<Button appearance="primary" onClick={onEditData} data-testid="edit-data-btn">
					{STATION_VIEWER_TEXTS.editData}
				</Button>
			</div>
		</div>
	);
};

export default StationViewer;
